import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

export const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col lg={{ span: 2 }}>
            <h4>Contact</h4>
            <p>Email: mohamadtarabin@outlook.com</p>
          </Col>
        </Row>
        <hr className="bg-light" />
        <p className="text-center">
          &copy; {new Date().getFullYear()} Mohamad Tarabin. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};
